import { Outlet } from "react-router-dom";
import { Container, Image, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Footer from "./Footer";
import unia from './img/unia.png';

let Layout = () => {

    return( 
        <div className = "d-flex flex-column min-vh-100">           
            <Navbar id = "nav" collapseOnSelect expand = "lg" bg = "light" variant = "light">
                <Container>
                    <LinkContainer to = "/">
                        <Navbar.Brand>
                            <Image src="https://www.zsi.kielce.pl/wp-content/uploads/2020/03/logo-desktop.png" height={40} />
                        </Navbar.Brand>
                    </LinkContainer>

                    <Navbar.Toggle />
                    <Navbar.Collapse>
                        <Nav className = "justify-content-end flex-grow-1 pe-3">
        
                            <LinkContainer to = "/aktualnosci">
                                <Nav.Link>Aktualności</Nav.Link>
                            </LinkContainer>

                            <LinkContainer to = "/rekrutacja">
                                <Nav.Link>Rekrutacja</Nav.Link>
                            </LinkContainer>

                            <LinkContainer to = "/partnerzy">
                                <Nav.Link>Instytucje</Nav.Link>
                            </LinkContainer>

                            <NavDropdown title="Wyjazdy">
                                    
                                    <NavDropdown.Item>
                                        <LinkContainer to = "/uczniowie">
                                            <Nav.Link>Uczniowie</Nav.Link>
                                        </LinkContainer>
                                    </NavDropdown.Item>
                                
                                
                                    <NavDropdown className="px-3" title="Nauczyciele">
                                        <NavDropdown.Item>
                                            <LinkContainer to = "/jobshadowing">
                                                <Nav.Link>Job shadowing</Nav.Link>
                                            </LinkContainer>
                                        </NavDropdown.Item>
                                
                                        <NavDropdown.Item>
                                            <LinkContainer to = "/kurs">
                                                <Nav.Link>Kurs programowania</Nav.Link>
                                            </LinkContainer>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                
                            </NavDropdown>

                            <LinkContainer to = "/kontakt">
                                <Nav.Link>Kontakt</Nav.Link>
                            </LinkContainer>

                            <LinkContainer to = "/linki">
                                <Nav.Link>Linki</Nav.Link>
                            </LinkContainer>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            
            <Outlet />

            <br /><hr /><br />
            <div className = "opinions2">
                <p><i>Dofinansowane ze środków UE. Wyrażone poglądy i opinie są jedynie opiniami autora lub autorów i niekoniecznie odzwierciedlają poglądy i opinie Unii Europejskiej lub Fundacji Rozwoju Systemu Edukacji. Unia Europejska ani Fundacja Rozwoju Systemu Edukacji nie ponoszą za nie odpowiedzialności.</i></p>
            </div>
            <div className = "logotypeContainer"> <img className = "logotype" src = {unia} />
            </div><br/>

            <Footer />

        </div>
    )
}

export default Layout;